//
import { Accept, DropzoneOptions, useDropzone } from 'react-dropzone';
import { Icon } from '@iconify/react';
import { Theme } from '@mui/material';
// @mui
import { styled, SxProps, useTheme } from '@mui/material/styles';

// ----------------------------------------------------------------------

const DropZoneStyle = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  maxHeight: 170,
  outline: 'none',
  display: 'flex',
  textAlign: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.neutral,
  border: `2px solid ${theme.palette.divider}`,
  '&:hover': { opacity: 0.72, cursor: 'pointer' },
  [theme.breakpoints.up('md')]: { textAlign: 'left', flexDirection: 'row' },
}));

// ----------------------------------------------------------------------

interface Props extends DropzoneOptions {
  error?: boolean;
  files: File[];
  showPreview: boolean;
  accept?: Accept;
  showFileIcon: boolean;
  sx?: SxProps<Theme>;
}
/**
 * (Component) 데이터 전처리 화면 파일 업로드
 *
 * @description 데이터 전처리 화면의 파일 분석 후 파일 임시 저장 부분
 * @parent_component_link {@link UploadDataSetUpload}
 * @layer upload-dataset[2]
 *
 * @param error 파일 임시 저장 시에 에러 발생 여부
 * @param showPreview 파일 미리보기(only Image)
 * @param files 임시 저장된 fileList
 * @function onRemove file 삭제 시 callback fuc
 * @param path 해당 파일 임시 저장 경로
 * @param preview 미리보기 시 파일 이름
 * @param acceptType 파일 확장자
 * @param showFileIcon 파일 아이콘
 *
 */
export default function FileUpload({ error, maxFiles, accept, sx, ...other }: Props) {
  const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
    ...other,
    accept: accept,
    maxFiles: maxFiles,
    onDropRejected: (fileRejections) => {
      fileRejections.forEach((fileRejection) => {
        const rejectedFile = fileRejection.file;
        alert(`${rejectedFile.name}은(는) 허용되지 않는 파일 형식입니다.`);
      });
    },
  });
  const theme = useTheme();

  return (
    <DropZoneStyle
      {...getRootProps()}
      sx={{
        ...(isDragActive && { opacity: 0.72, bgcolor: '#ffffff' }),
        ...((isDragReject || error) && {
          color: 'error.main',
          ...sx,
        }),
      }}
    >
      <input {...getInputProps()} />
      <Icon icon="ic:round-plus" width={'20%'} color={theme.palette.grey[400]} />
    </DropZoneStyle>
  );
}
